<template>
  <img src="../assets/images/netcorelogo-white.svg" :height="Number(height)" :width="Number(width)" alt="netcorelogo" />
</template>

<script setup>
// import { useColors } from 'vuestic-ui'

// const { getColor } = useColors()

// eslint-disable-next-line vue/require-prop-types
const props = defineProps(['height', 'width'])
console.log(props.height, props.width)
// const props = withDefaults(
//   defineProps<{
//     height
//     width
//     start?: string
//     end?: string
//   }>(),
//   {
//     height: 18,
//     start: 'primary',
//     end: undefined,
//   },
// )

// const colorsComputed = computed(() => {
//   return {
//     start: getColor(props.start),
//     end: getColor(props.end || props.start),
//   }
// })
</script>
